export default "__VITE_ASSET__0439bae4__"